<template>
  <div>
    <b-modal
      id="notice-cod-info-modal"
      v-model="modal.open"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      size="lg"
      @hidden="onClose()"
      title="รายละเอียดเพิ่มเติม"
    >
      <b-carousel
        id="notice-cod-info-carousel"
        controls
        background="#fff"
        :interval="6000"
        class="custom-carousel"
      >
        <b-carousel-slide
          v-for="(image, index) in currentThemeImages"
          :key="index"
          :img-src="image"
          class="carousel-image"
        ></b-carousel-slide>
      </b-carousel>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      modal: Object,
      onClose: Function
    },
    data() {
      return {
        shippop_images: [
          require('@/assets/images/cod/shippop/guide-cod-1.png'),
          require('@/assets/images/cod/shippop/guide-cod-2-pop.png'),
          require('@/assets/images/cod/shippop/guide-cod-3.png'),
        ],
        postmanservice_images: [
          require('@/assets/images/cod/postmanservice/guide-cod-1.png'),
          require('@/assets/images/cod/postmanservice/guide-cod-2-pop.png'),
          require('@/assets/images/cod/postmanservice/guide-cod-3.png'),
        ]
      };
    },
    computed: {
      currentThemeImages() {
        if (this.$THEME.name === 'shippop') {
          return this.shippop_images;
        } else if (this.$THEME.name === 'postmanservice') {
          return this.postmanservice_images;
        } else {
          return [];
        }
      }
    },
  };
</script>

<style scoped>
.carousel-image {
  height: 60vw;
  max-height: 900px;
  overflow: hidden;
}

.carousel-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
}

.custom-carousel {
  text-shadow: 1px 1px 2px #333;
}
</style>
